import React, { useState } from "react";
import Select from "react-select";
import Modal from "react-modal";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { notify, formDataHelper } from "../../../../util/helpers";
import { useSelector, useDispatch } from "react-redux";
import {
    addPatientLogic,
} from "../../../../store/features/patient/patientSlice";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import { DatePicker, DateRangePicker } from "rsuite";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import "../../patient/PatientStyles.css";
import moment from "moment";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
  },
};

const AddNewPatient = ({ modalIsOpen, setIsOpen }) => {
  Modal.setAppElement("#root");
  const [loading, setLoading] = useState(false);
  const [dob, setDOB] = useState(null);
  const { selectedClinic } = useSelector((state) => state.app);
  const { afterToday, beforeToday } = DateRangePicker;
  const dispatch = useDispatch();
  const options = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
  ];

  function closeModal() {
    if (loading) {
      notify("Please wait while the patient is being invited", "info");
      return;
    }
    setIsOpen(false);
  }
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevents default behavior for Enter key
    }
  };

  const handleSubmit = (e) => {
    console.log("event", e.key);
    e.preventDefault();

    try {
      if (loading) {
        notify("Please wait while the patient is being invited", "info");
        return;
      }
      setLoading(true);
      let formData = new FormData(e.target);
      formData.append("date_of_birth", dob && moment(dob).format("YYYY-MM-DD"));
      const data = formDataHelper(formData, true);
      data["pin"] = selectedClinic?.pin;
      data["password"] = "Rose12345";
      data["username"] = data?.email;
      data["invite"] = "false";
    //   data["clinic"] = selectedClinic?.clinic?.id; invite
    //   data["clinician"] = selectedClinic?.clinic_admin;
    
      console.log("data", data);
      
      //return;
      addPatientLogic(data)
        .then((res) => {
          setLoading(false);

          if (res?.status === 201 || res?.status === 200) {
            notify("Patient added successfully!");
            closeModal();
          } else {
            notify("Something went wrong! Try again later!", "error");
          }
        })
        .catch((e) => {
          setLoading(false);
          notify("Something went wrong! Try again later!", "error");
        });
    } catch (e) {
      setLoading(false);
      notify("Something went wrong! Try again later!", "error");
    }
  };
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
      >
        <div className="container-fluid">
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          <CardLayout className="p-3">
            <div className="w-100 pt-2 d-flex justify-content-start">
              <h3 className="primary-text-blue">Add New Patient</h3>
            </div>
            <form onSubmit={handleSubmit} className="container-fluid p-1 row">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="form-group py-3">
                  <label>First Name *</label>
                  <input
                    tabindex="1"
                    required
                    name="first_name"
                    id="first_name"
                    placeholder="Enter First Name"
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="form-group py-3">
                  <label>Phone Number</label>
                  <input
                    tabindex="3"
                    name="cell_number"
                    id="cell_number"
                    maxLength={10}
                    minLength={10}
                    placeholder="Enter Phone Number"
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="form-group py-3">
                  <label>Date of Birth</label>
                  <DatePicker
                    tabindex="5"
                    placeholder="-- --"
                    appearance="subtle"
                    name="date_of_birth"
                    id="date_of_birth"
                    value={dob}
                    oneTap
                    onChange={setDOB}
                    caretAs={CalendarIcon}
                    shouldDisableDate={afterToday()}
                    format="MM/dd/yyyy"
                    className="custom-datepicker"
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="form-group py-3">
                  <label>Last Name *</label>
                  <input
                    tabindex="2"
                    required
                    name="last_name"
                    id="last_name"
                    placeholder="Enter Last Name"
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="form-group py-3">
                  <label>Email Address</label>
                  <input
                    tabindex="4"
                    type="email"
                    placeholder="Enter Email Address"
                    name="email"
                    id="email"
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="form-group py-3">
                <label>Gender</label>
                <Select
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      border: "0px",
                      borderBottom: "1px solid #94A3B8",
                      borderRadius: "0px",
                      padding: "5px",
                    }),
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder="Gender"
                  classNamePrefix="select"
                  name="gender"
                  options={options}
                />
              </div>
              </div>
              <div
                className="container-fluid w-100 d-flex justify-content-end"
                style={{ gap: "30px" }}
              >
                <button
                  className="btn alternative-btn"
                  style={{ padding: "10px 20px", width: "20%" }}
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="primary-btn"
                  style={{ padding: "10px 20px !important", width: "20%" }}
                >
                  Add Patient
                </button>
              </div>
            </form>
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};
export default AddNewPatient;
